import React from 'react';
import { MessageResponse } from '@ujet/websdk-headless';
import { TextMessage } from './components/TextMessage/TextMessage';
import { PhotoMessage } from './components/PhotoMessage';
import { InlineButtons } from './components/InlineButtons';
import { Notification } from './components/Notification';
import { ProductCards } from './components/ProductCards/ProductCards';

interface MessageProps {
  message: MessageResponse;
  index: number;
  messagesLength: number;
  scrollToBottom: () => void;
}

export const Message = ({ message, index, messagesLength, scrollToBottom }: MessageProps): React.ReactElement => {
  switch (message.type) {
  case 'noti':
    return <Notification message={ message } />;
  case 'text':
    return <TextMessage message={ message } isFirstUserMessage={ index == 1 } />;
  case 'photo':
    return <PhotoMessage message={ message } scrollToBottom={ scrollToBottom } />;
  case 'inline_button':
    return <InlineButtons message={ message } isFirstMessage={ index === 0 } isLastMessage={ index === messagesLength - 1 } />;
  case 'content_card':
    return <ProductCards message={ message } scrollToBottom={ scrollToBottom } />;
  default:
    return null;
  }
};
